import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { Table } from '../../../_models/table';
import { TableComponent } from './table/table.component';
import {
  Component,
  ViewChild,
  ViewContainerRef,
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  ComponentRef,
  ElementRef,
  Inject,
  PLATFORM_ID,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';

@Directive({
    selector: '[appDynamic]',
    standalone: false
})
export class DynamicDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}

@Component({
    selector: 'app-reservation-map',
    templateUrl: './reservation-map.component.html',
    styleUrls: ['./reservation-map.component.scss'],
    standalone: false
})
export class ReservationMapComponent implements AfterViewInit, OnChanges {
  @Input() tables: Table[];
  @Input() isRestuarant = true;
  @ViewChild(DynamicDirective, { static: true })
  private dynamicHost!: DynamicDirective;

  @ViewChild('mobileHelp')
  private mobileHelp!: ElementRef<HTMLDivElement>;
  @ViewChild('container')
  private container!: ElementRef<HTMLDivElement>;
  isMobile: boolean = false;
  tablesComponentsRef: ComponentRef<TableComponent>[] = [];
  tablesSubs: Subscription;
  constructor(
    private changeRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tables']) {
      if (this.tablesSubs) this.tablesSubs.unsubscribe();
      const viewContainerRef = this.dynamicHost.viewContainerRef;
      viewContainerRef.clear();
      for (let table of this.tables) {
        const componentRef =
          viewContainerRef.createComponent<TableComponent>(TableComponent);
        componentRef.instance.table = table;
        componentRef.injector.get(ChangeDetectorRef).detectChanges();
        componentRef.instance.positionTable(table);
        this.tablesComponentsRef.push(componentRef);
      }
    }

    this.changeRef.detectChanges();
  }

  ngAfterViewInit(): void {
    this.container.nativeElement.scrollLeft =
      (this.container.nativeElement.scrollWidth -
        this.container.nativeElement.clientWidth) /
      2;
    if (isPlatformBrowser(this.platformId))
      setTimeout(() => {
        this.mobileHelp.nativeElement.classList.add('make-transparent');
        setTimeout(() => {
          this.mobileHelp.nativeElement.remove();
        }, 2000);
      }, 2000);
  }
}
